export const DISTINCT_ADDITIONAL_EMAIL_ERROR = "Email addresses must be unique";

const getEmailIndex = (name = "") => {
  const matches = /\[(\d+)\]/.exec(name);

  return matches ? Number(matches[1]) : -1;
};

const normalize = (value) => value?.trim().toLowerCase();

export const distinctAdditionalEmail = (value, allValues = {}, _, name) => {
  const normalizedValue = normalize(value);
  if (!normalizedValue) {
    return undefined;
  }

  if (normalize(allValues.email) === normalizedValue) {
    return DISTINCT_ADDITIONAL_EMAIL_ERROR;
  }

  const additionalEmails = Array.isArray(allValues.additionalEmails)
    ? allValues.additionalEmails
    : [];
  const currentIndex = getEmailIndex(name);

  const hasDuplicateAdditionalEmail = additionalEmails.some((email, index) => {
    if (index === currentIndex) {
      return false;
    }

    return normalize(email) === normalizedValue;
  });

  return hasDuplicateAdditionalEmail
    ? DISTINCT_ADDITIONAL_EMAIL_ERROR
    : undefined;
};
